import React from 'react';
import styled from 'styled-components';

import { HintButton, Bubble } from '@lt/components';
import { CDN_PATH } from '../../constants/common';
import ExtraPropTypes from '../../routes/Checkout/CheckoutRoutes/PackageCheckout/proptypes/extras';

const getExtraIcon = (src) => {
  const defaultImage = 'partner_logos/bonus_extra/2/insurance.png';
  const image = src || defaultImage;

  return [CDN_PATH, image].join('/');
};

const LTExtra = ({
  className = '',
  isMobile,
  isCompact,
  name,
  description,
  tooltip,
  icon_path: icon,
}) => (
  <StyledContainer className={className}>
    <Icon isCompact={isCompact} $src={icon} />

    <StyledTextContainer isCompact={isCompact}>
      <StyledText isMobile={isMobile}>{name}</StyledText>

      {!isCompact && (
        <StyledAdditionalText isMobile={isMobile}>
          <span>{description}</span>
          {tooltip && (
            <>
              &nbsp;
              <Bubble text={tooltip} inline>
                <HintButton />
              </Bubble>
            </>
          )}
        </StyledAdditionalText>
      )}
    </StyledTextContainer>
  </StyledContainer>
);

const StyledContainer = styled.div`
  display: flex;
`;
const Icon = styled.div`
  margin-right: 10px;
  min-width: 44px;
  max-width: 44px;
  height: 40px;
  background-image: ${({ $src }) => `url(${getExtraIcon($src)}) `};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  ${({ isCompact }) =>
    isCompact &&
    `
    margin-right: 6px;
    width: 24px;
    height: 24px;
  `}
`;
const StyledTextContainer = styled.div`
  margin-top: 7px;
  display: flex;
  flex-direction: column;
  ${({ isCompact }) =>
    isCompact &&
    `
    justify-content: center;
    margin-top: 2px;
  `};
`;
const StyledText = styled.span`
  font-size: ${({ isMobile }) => (isMobile ? 13 : 14)}px;
  color: ${({ theme }) => theme.colors.blackLight};
`;
const StyledAdditionalText = styled.div`
  font-size: ${({ isMobile }) => (isMobile ? 12 : 11)}px;
  color: ${({ theme }) => theme.colors.greyLight};

  ${Icon} {
    margin-left: 0.6ch;
  }
`;

LTExtra.propTypes = ExtraPropTypes.itemParams;

export default LTExtra;
